var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-h4 pa-2"},[_vm._v("\n    "+_vm._s(_vm._f("separadores")(_vm.valor))+"\n    "),_c('span',{staticClass:"text-subtitle-1 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.etiqueta_unidad))])])
}
var staticRenderFns = []

export { render, staticRenderFns }